import ShareForwardIcon from '@/assets/icons/Share-Forward';
import useStore from '@/lib/store';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

type ProjectExp = {
  item: any;
  index: number;
};

export const LandExprired: FC<ProjectExp> = ({ item, index }) => {
  const { t } = useTranslation();
  const { plants, landTypes, landStatic, fondTypes, massives, plantsTypes } =
    useStore();
  const { id } = useParams();

  return (
    <div className="w-full flex flex-col border border-gray-smoke rounded-xl overflow-hidden">
      <div className="w-full grid grid-cols-11 gap-7 bg-green-light py-4 px-6">
        <div className="col-span-2 flex items-center  gap-10">
          <p className="text-sm font-light">
            {t('date')}:{' '}
            <span className="font-medium text-sm">
              {item?.merge_details?.created_at
                ? new Date(item.merge_details.created_at).getFullYear()
                : '-'}
            </span>
          </p>
          <p className="text-sm font-light">
            {t('crop.id')}:{' '}
            <span className="font-medium text-sm">
              {item.merge_details?.crop_id || '-'}
            </span>
          </p>
        </div>

        <div className="col-span-4 flex items-center gap-4">
          <p className="text-sm font-light">
            {t('cadastral.number')}:{' '}
            <span className="font-medium text-sm">
              {item?.contour_details?.cad_number || '-'}
            </span>
          </p>
          <div className="flex gap-2.5">
            <a
              href={`https://crop2.agro.uz/?land=${item?.merge_details?.contour_id}`}
              target="_blank"
            >
              <ShareForwardIcon />
            </a>
          </div>
        </div>
        <div className="col-span-2">
          <p className="text-sm font-light">
            {t('area')}:{' '}
            <span className="font-medium text-sm">
              {item?.contour_details?.area}
            </span>
          </p>
        </div>
        <div className="col-span-2">
          <p className="text-sm font-light">
            {t('contour.number')}:{' '}
            <span className="font-medium text-sm">
              {item?.merge_details?.contour_number}
            </span>
          </p>
        </div>
        {/* <div className="col-span-1 flex justify-center">
          {index > 1 && (
            <Button
              variant="ghost"
              className="p-0 hover:bg-transparent"
              onClick={() => onDelete({ contour_id: item.merge_details?.id })}
            >
              <Trash2 className="stroke-red-default" />
            </Button>
          )}
        </div> */}
      </div>
      <div className="w-full grid grid-cols-11 gap-7 bg-white py-4 px-6">
        <div className="col-span-2">
          <p className="text-xs">{t('type.land')}:</p>
          <p className="text-sm">
            {landTypes?.find(
              (el) => el?.id === Number(item?.merge_details?.land_type),
            )?.name || '-'}
          </p>
        </div>
        <div className="col-span-3">
          <p className="text-xs">{t('type.land')}:</p>
          <p className="text-sm">
            {landStatic?.find(
              (el) =>
                el.id === Number(item?.merge_details?.land_extra_irragation),
            )?.name_lat || '-'}
          </p>
        </div>
        <div className="col-span-2">
          <p className="text-xs">{t('land.fund.category')}:</p>
          <p className="text-sm">
            {fondTypes?.find(
              (el) => el?.id == Number(item?.merge_details?.fond_type_id),
            )?.name || '-'}
          </p>
        </div>
        <div className="col-span-2">
          <p className="text-xs">{t('array')}:</p>
          <p className="text-sm">
            {massives?.find(
              (el) => el?.id === Number(item?.merge_details?.massiv_id),
            )?.name || '-'}
          </p>
        </div>
        <div className="col-span-2">
          <p className="text-xs">{t('plant.name')}:</p>
          <p className="text-sm font-semibold">
            {plants?.find(
              (el) => el.id === String(item?.merge_details?.plant_id),
            )?.name || '-'}
          </p>
        </div>
        <div className="col-span-2">
          <p className="text-xs">
            {t('plant.type')}/{t('fruit.type')}:
          </p>
          <p className="text-sm">
            {plantsTypes?.find(
              (el) => el.id === String(item.merge_details?.plant_type_id),
            )?.name || '-'}
          </p>
        </div>

        <div className="col-span-2">
          <p className="text-xs">{t('score.rating')}:</p>
          <p className="text-sm">{item?.merge_details?.ball_bonitet || '-'}</p>
        </div>
      </div>
    </div>
  );
};
